module.exports = __webpack_public_path__ + "img/05_sub_no.99d90a33.svg";